import React, { Component } from "react"
const X = props => (
  <svg {...props} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M12.8 0H16V3.2H12.8V0ZM9.6 6.4V3.2H12.8V6.4H9.6ZM9.6 9.6V6.4H6.4V3.2H3.2V0H0V3.2H3.2V6.4H6.4V9.6H3.2V12.8H0V16H3.2V12.8H6.4V9.6H9.6ZM12.8 12.8H9.6V9.6H12.8V12.8ZM12.8 12.8H16V16H12.8V12.8Z" fill="#CCCCCC"/>
  </svg>
)

export default X 
